import React, { useEffect, useState } from 'react';
import styles from './InterimResultsDisplay.module.css';

const InterimResultsDisplay = ({ 
    interimText, 
    isListening, 
    position = 'compact' // 'compact', 'inline'
}) => {
    const [displayText, setDisplayText] = useState('');
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (interimText && interimText.trim()) {
            setDisplayText(interimText);
            setIsVisible(true);
        } else if (!isListening) {
            setIsVisible(false);
            setTimeout(() => setDisplayText(''), 200);
        }
    }, [interimText, isListening]);

    if (!isListening && !displayText) {
        return null;
    }

    return (
        <div className={`${styles.container} ${styles[position]} ${isVisible ? styles.visible : styles.hidden}`}>
            <div className={styles.content}>
                <div className={styles.statusIcon}>
                    <i className={`fas fa-microphone-alt ${isListening ? styles.listening : ''}`}></i>
                </div>
                <div className={styles.textArea}>
                    {displayText ? (
                        <span className={styles.interimText}>{displayText}</span>
                    ) : (
                        <span className={styles.placeholder}>Start speaking...</span>
                    )}
                    {isListening && displayText && <span className={styles.cursor}>|</span>}
                </div>
            </div>
        </div>
    );
};

export default InterimResultsDisplay;